<tui-textfield
  tuiChevron
  [stringify]="stringifyThemeOptions"
  [content]="themeOptionContent"
  class="min-w-[180px]"
  [tuiTextfieldSize]="$size()"
  [tuiTextfieldCleaner]="false"
>
  <input
    tuiSelect
    [(ngModel)]="currentTheme"
    (ngModelChange)="setTheme(currentTheme)"
  />
  <label tuiLabel class="x-font-body-4-bold x-text-dark-main">
    {{ 'core.sidebar.theme' | translate }}
  </label>
  <tui-data-list-wrapper
    *tuiDropdown
    [itemContent]="themeOptionContent"
    [items]="themeOptions"
  ></tui-data-list-wrapper>
</tui-textfield>

<ng-template #themeOptionContent let-item>
  <div class="flex flex-row items-center gap-2.5">
    <tui-icon [icon]="item.icon" class="size-6 text-base"></tui-icon>
    <p class="x-font-body-4 x-text-dark-main">
      {{ 'core.sidebar.' + item.name | translate }}
    </p>
  </div>
</ng-template>
